'use strict';

var _ = require('lodash');
var TDChartClassesAggregationFactory = function TDChartClassesAggregationFactory(DataAggregationFactory, ExtractMetricKeysService, configurationService, fcrService) {
  var classesByMarketMap;
  function TDChartClassesAggregation() {
    DataAggregationFactory.call(this, 'service', 'thematic-demand-chart-service-classes');
    classesByMarketMap = createClassesByMarketMap();
  }
  TDChartClassesAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartClassesAggregation.constructor = DataAggregationFactory;
  function mapClasses(serviceClassGroupConfig) {
    return _.chain(serviceClassGroupConfig).sortBy('classIndex').map('className').uniq().value();
  }
  function createClassesByMarketMap() {
    var marketServiceClassGroupConfig = configurationService.getClassGroupConfig();
    return _.mapValues(marketServiceClassGroupConfig, mapClasses);
  }
  function getClassesByMarket(classGroupIndicesKey, classGroupIndicesKeyWithoutFCRTag) {
    return classesByMarketMap[classGroupIndicesKey] || classesByMarketMap[classGroupIndicesKeyWithoutFCRTag] || classesByMarketMap["default"];
  }
  function getClassGroupIndicesKey(data) {
    var fcrTag = fcrService.getFcrTagForMultipleEntities(data, 'departureDateMoment');
    return data && data.length && data[0].market + (fcrTag.length > 0 ? '-' : '') + fcrTag;
  }
  function getClassGroupIndicesKeyWithoutFCRTag(data) {
    return data && data.length && data[0].market;
  }
  TDChartClassesAggregation.prototype.sortClassesByIndex = function (aggregatedClassNames, data) {
    var sortedClasses = [];
    var classGroupIndicesKey = getClassGroupIndicesKey(data);
    var classGroupIndicesKeyWithoutFCRTag = getClassGroupIndicesKeyWithoutFCRTag(data);
    var uniqClassNames = getClassesByMarket(classGroupIndicesKey, classGroupIndicesKeyWithoutFCRTag);
    _.forEach(uniqClassNames, function (clazz) {
      if (typeof aggregatedClassNames[clazz] !== 'undefined') {
        sortedClasses.push(aggregatedClassNames[clazz]);
      }
    });
    if (_.isEmpty(sortedClasses)) {
      return this.sortAggregationResults(aggregatedClassNames);
    }
    return sortedClasses;
  };
  TDChartClassesAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedClassNames = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedClassNames[data[index].className])) {
        aggregatedClassNames[data[index].className].push(data[index]);
      } else {
        aggregatedClassNames[data[index].className] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedClassNames);
    if (Object.keys(aggregatedClassNames).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedClassNames[Object.keys(aggregatedClassNames)[0]][0]);
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      aggregationFunction(aggregatedClassNames[keys[index]], metricKeys, reducedEntry);
      aggregatedClassNames[keys[index]] = reducedEntry;
    }
    return this.sortClassesByIndex(aggregatedClassNames, data);
  };
  return TDChartClassesAggregation;
};
TDChartClassesAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService', 'ConfigurationService', 'FcrService'];
module.exports = TDChartClassesAggregationFactory;